import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Console } from '@partners/utils';

export class SimpleErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;

    const { errors } = control;

    let isInValid;

    if (errors && errors['required']) {
      isInValid = control?.invalid && (control.dirty || control.touched || isSubmitted);
      // Console.logWarning(
      //   `invalid: ${control?.invalid} | dirty: ${control.dirty} | touched: ${control.touched} | submitted: ${isSubmitted} | has error: ${isInValid}`
      // );
      return isInValid;
    }

    isInValid = control?.invalid && (control.dirty || control.touched);
    // Console.logInfo(
    //   `invalid: ${control?.invalid} | dirty: ${control.dirty} | touched: ${control.touched} | submitted: ${isSubmitted} | has error: ${isInValid}`
    // );
    return isInValid;
  }
}
